import mergeProps from "@/router/utils/mergeProps";
import redirectByName from "@/router/utils/redirectByName";

// Keep this static: the tools shell is part of the critical first render for genogram SEO paths.
// Splitting it would add another immediate request without deferring meaningful work.
import ToolsMain from '@/tools/ToolsMain'
let ScheduleMaker = () => import(/* webpackChunkName: "ScheduleMakerTool" */ '@/tools/ScheduleMaker/ScheduleMaker')
// Keep this static: genogram is the primary high-traffic SEO entry and this component is needed immediately.
// Making it async would likely turn one required download into multiple startup requests.
import GenogramToolMain from '@/tools/GenogramTool/GenogramToolMain'
let GenogramRenderPreview = () => import(/* webpackChunkName: "genogram-render-preview" */ '@/tools/GenogramTool/RenderPreview/GenogramRenderPreview.vue')
let TimelineToolMain = () => import(/* webpackChunkName: "TimelineTool" */ '@/tools/TimelineTool/TimelineToolMain')
let IFSPartsToolMain = () => import(/* webpackChunkName: "IFSPartsTool" */ '@/tools/IFSMappingParts/IFSPartsToolMain.vue')

let GenogramClassEnroll = () => import(/* webpackChunkName: "genogram-for-class-enroll" */ '@/tools/GenogramTool/Enroll/GenogramClassEnroll.vue')
let GenogramClassLanding = () => import(/* webpackChunkName: "genogram-for-class" */ '@/tools/GenogramTool/Enroll/GenogramClassLanding.vue')
let PublicToolDemoRoutePage = () => import(/* webpackChunkName: "tool-demo-route" */ '@/core/modules/coach/Resources/CoachingTools/GenericTools/PublicDemo/PublicToolDemoRoutePage.vue')

export default [
	{
		path: '/tools',
		name: 'tools',
		component: ToolsMain,
		props: true,
		meta:{
			isWhitelisted: true
		},
		children: [
			{
				path: '',
				beforeEnter(to, from, next) {
					if (typeof window !== "undefined") {
						window.location.assign("https://qwoach.com")
					}
					next(false)
				},
				meta:{
					isWhitelisted: true,
				},
			},
			{
				path: 'wheel-of-life',
				name: 'WheelOfLife',
				props: () => ({
					slug: "wheel-of-life",
				}),
				component: PublicToolDemoRoutePage,
				meta:{
					isWhitelisted: true,
				},
			},
			{
				path: 'genogram/render-preview',
				name: 'GenogramRenderPreview',
				props: route => ({
					...mergeProps(route),
				}),
				component: GenogramRenderPreview,
				meta:{
					isWhitelisted: true,
				},
			},
			{
				path: 'genogram',
				name: 'GenogramTool',
				props: route => ({
					...mergeProps(route),
					// settingsParam: {"showStudentEnrollment": true},
				}),

				component: GenogramToolMain,
				meta:{
					isWhitelisted: true,
				},
			},
			{
				path: 'genogram/test',
				name: 'GenogramToolTest',
				props: route => ({
					...mergeProps(route),
					// settingsParam: {"showStudentEnrollment": true},
					aiDevTest: true,
				}),

				component: GenogramToolMain,
				meta:{
					isWhitelisted: true,
				},
			},
			{
				path: 'genogram-online',
				name: 'GenogramToolNoTrial',
				props: route => ({
					...mergeProps(route),
					settingsParam: {"no-trial-monthly": true},
					otherParams: {
						yearMonthNoTrial: 		 "opt=eyJ5IjogODk3MTY0LCAibSI6IDg5NTk0NCwgInBtIjogOSwgInB5IjogNDl9",
						yearMonthNoTrialStudent: "opt=eyJ5IjogODk3MTY0LCAibSI6IDg5NTk0NCwgInBtIjogOSwgInB5IjogNDksICJzZSI6IHRydWV9",
					}
				}),

				component: GenogramToolMain,
				meta:{
					isWhitelisted: true,
				},
			},
			{
				path: 'genogram/:teacherId',
				name: 'GenogramStudent',
				props: route => ({
					...mergeProps(route),
					// settingsParam: {"no-trial-monthly": true},
				}),

				component: GenogramToolMain,
				meta:{
					isWhitelisted: true,
				},
			},

			{
				path: 'genogram-for-education',
				redirect: redirectByName('GenogramForClass'),

				children: [
					{
						path: "",
						name: 'GenogramForClass',
						// redirect: redirectByName('GenogramForClassEnroll'),
						props: route => ({
							...mergeProps(route),
							settingsParam: {"planIdYearly": "897643"},
						}),

						component: GenogramClassLanding,
						meta:{
							isWhitelisted: true,
						},
					},
					{
						path: "enroll",
						name: "GenogramForClassEnroll",
						props: route => ({
							...mergeProps(route),
							settingsParam: {"planIdYearly": "897643"},
						}),
						component: GenogramClassEnroll,
						meta:{
							isWhitelisted: true,
						},

					}
				]

			},

			{
				path: 'genogram-feedback',
				name: 'GenogramToolEmail',
				props: route => ({
					...mergeProps(route),
					settingsParam: {},//{"tutorial-off": true},
					utm_params: {utm_source: "email", utm_campaign: "genogram-cold-lmft"},
				}),

				component: GenogramToolMain,
				meta:{
					isWhitelisted: true,
				},
			},
			{
				path: 'genogram-online-feedback',
				name: 'GenogramToolLinkedin',
				props: route => ({
					...mergeProps(route),
					settingsParam: {},
					utm_params: {utm_source: "linkedin", utm_campaign: "genogram-cold-lmft"},
				}),

				component: GenogramToolMain,
				meta:{
					isWhitelisted: true,
				},
			},
			{
				path: 'ifs-parts-mapping',
				name: 'IfsPartsMappingTool',
				props: true,
				component: IFSPartsToolMain,
				meta:{
					isWhitelisted: true,
				},
			},
			{
				path: 'timeline',
				name: 'TimelineTool',
				props: true,
				component: TimelineToolMain,
				meta:{
					isWhitelisted: true,
				},
			},
			{
				path: 'free-schedule-maker',
				name: 'ScheduleMaker',
				component: ScheduleMaker,
				props: true,
				meta:{
					isWhitelisted: true,
				},
			},
			{
				path: ':slug',
				name: 'PublicToolDemoRoutePage',
				props: route => ({
					slug: route.params.slug,
				}),
				component: PublicToolDemoRoutePage,
				meta:{
					isWhitelisted: true,
				},
			},
		]
	},

]
